'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PhonenumberControl = function () {
  function PhonenumberControl(element, args) {
    var _this = this;

    _classCallCheck(this, PhonenumberControl);

    var div = document.createElement('div');
    this.input = document.createElement('input');
    this.input.id = window.PRIM.getUUID();
    this.input.value = args.value ? args.value : '';
    this.input.type = 'tel';
    this.input.autocapitalize = 'off';
    this.input.autocorrect = 'off';
    this.input.spellcheck = 'false';
    this.input.disabled = args.readonly ? 'disabled' : '';
    this.input.onchange = args.onchange;
    this.label = document.createElement('label');
    this.label.innerHTML = args.label;
    this.label.htmlFor = this.input.id;

    var onclick = function onclick() {
      if (_this.input.value) {
        var parsedPhonenumber = _this.input.value.trim().replace(/ *\([^)]*\) */g, '').replace(/[^+0-9.]/g, '');

        if (parsedPhonenumber) {
          if (parsedPhonenumber.length < 4) {
            alert('Telefoonummers korter dan 4 cijfers zijn zeer waarschijnlijk noodnummers. U kunt geen noodnummers bellen vanuit deze applicatie.');
            return;
          }

          location.href = 'tel:' + parsedPhonenumber;
        }
      }
    };

    var button = document.createElement('button');
    button.className = 'icon';
    button.innerHTML = '\uE0C5';
    button.onclick = onclick;

    var fragment = document.createDocumentFragment();
    fragment.appendChild(div);
    div.appendChild(this.label);
    div.appendChild(this.input);
    div.appendChild(button);

    element.appendChild(fragment);
  }

  _createClass(PhonenumberControl, [{
    key: 'setLabel',
    value: function setLabel(text) {
      this.label.innerHTML = text;
    }
  }, {
    key: 'getValue',
    value: function getValue() {
      return this.input.value ? this.input.value : null;
    }
  }, {
    key: 'setValue',
    value: function setValue(value) {
      this.input.value = value;
    }
  }]);

  return PhonenumberControl;
}();

exports.default = PhonenumberControl;


//////////////////
// WEBPACK FOOTER
// ./js/lib/ui/PhonenumberControl.js
// module id = 43
// module chunks = 0